// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"12602b5c","213":"6bb351f3","415":"4c2cc51c","453":"e95f3f17","455":"05353db0","937":"244d187c"}[chunkId] + ".chunk.js";
};